import React, { useEffect, useState } from 'react';
import { PNSnackbar, SNACKBAR_TYPES } from './PNSnackbar';
import { useIntl } from 'react-intl';
import { SNACKBAR_DIV } from '../Layout/MainLayout/MainLayout';
import { renderIntoIdWithProviders } from '../../utils/render';

const ERROR_AUTO_HIDE_DURATION = 6000;
const SUCCESS_AUTO_HIDE_DURATION = 12000;

export const useShowGeneraSnackbar = () => {
  const intl = useIntl();
  const errorBody = intl.formatMessage({ id: 'app.error' });
  const { showSnackbar } = useShowSnackbar(
    SNACKBAR_TYPES.error,
    ERROR_AUTO_HIDE_DURATION,
    errorBody);
  const { showSnackbar: showSnackbarSuccess } = useShowSnackbar(
    SNACKBAR_TYPES.success,
    SUCCESS_AUTO_HIDE_DURATION);
  return {
    showSnackbarGeneralError: showSnackbar,
    showSnackbarSuccess,
  };
};

export const useShowSnackbar = (type, autoHideDuration, children) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarChildren, setSnackbarChildren] = useState(children);
  useEffect(() => {
    renderIntoIdWithProviders(
      <PNSnackbar
        key={'errorkey'}
        type={type}
        open={snackbarOpen}
        autoHideDuration={autoHideDuration}
        onClose={() => {
          setSnackbarOpen(false);
        }}
      >
        {snackbarChildren}
      </PNSnackbar>
      , SNACKBAR_DIV,
    );
  },
  [snackbarOpen, setSnackbarOpen, type, autoHideDuration, snackbarChildren],
  );
  const showSnackbar = (children) => {
    if (children) setSnackbarChildren(children);
    setSnackbarOpen(true);
  };
  return { showSnackbar };
};

